<template>
  <div>
    <McGrapqlTable
      :fields="fields"
      :apiClient="query"
      :searchable="false"
      :withCard="true"
      :isSelectableField="false"
      trackBy="vgroupId"
      :isEmpty="!hasData"
      :emptyButton="true"
      :customButton="true"
      :refreshData="!loading"
      bulkDeleteApi
    >
      <template #title>
        <h4 class="card-title">
          {{ $t('notification.setting.emailNotification.listFleetGroup') }}
        </h4>
      </template>

      <template #button-value-help>
        <McButtonValueHelp
          icon="icon-outline_plus"
          :text="$t('global.create')"
          :label="$t('setting.list.fleetGroup.form.createFleetGroup')"
          :multiple="true"
          trackBy="id"
          :listGetter="vgroupQuery.get"
          :tableFields="vgroupFields"
          class="me-2"
          :disabled="isAdding || loading"
          @selected="addVgroup"
        />
      </template>

      <template #emptyState>
        <McEmptyState
          :title="$t('notification.setting.emptyState.vGroupAdd')"
          :desc="$t('notification.setting.emptyState.desc')"
          class="pb-4"
          placementType="grid"
          :hasButton="false"
          :disabled="isAdding"
        />
      </template>
    </McGrapqlTable>
  </div>
</template>

<script>
import McGrapqlTable from '@/components/McGrapqlTable'
import McEmptyState from '@/components/McEmptyState'
import McButtonValueHelp from '@/components/McButtonValueHelp'
import { GET_VGROUPS_PAGINATED } from '@/services/api/vehicle/vgroup'
import { UPDATE_NOTIFICATION_GROUP } from '@/services/api/notification/ngroup'
import { GET_NGROUP_2_SOURCES } from '@/services/api/notification/ngroup2Source'

export default {
  components: {
    McGrapqlTable,
    McEmptyState,
    McButtonValueHelp,
  },
  apollo: {
    ngroup2Sources: {
      query: GET_NGROUP_2_SOURCES,
      fetchPolicy: 'no-cache',
      variables() {
        return {
          filter: {
            ngroupId: Number(this.ngroupId),
            pagination: {
              page: 1,
              show: 9999,
            },
          },
        }
      },
      skip() {
        return !this.ngroupId
      },
      result({ data, loading }) {
        if (!loading) {
          this.vgroups = data.ngroup2Sources.ngroup2Sources.data
          this.excludeVgroupId = this.vgroups.map((item) => item.vgroupId)
        }
      },
    },
  },
  props: {
    isAdding: {
      type: Boolean,
      required: true,
    },
    ngroupId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      hasData: false,
      loading: true,
      vgroups: [],
      excludeVgroupId: [],
    }
  },

  computed: {
    fields() {
      return [
        {
          key: 'vgroup',
          label: this.$t('setting.list.userSetting.grupKendaraan'),
          isSortable: true,
          isResponsive: true,
          formatter: (val) => val.name,
        },
      ]
    },

    vgroupFields() {
      return [
        {
          key: 'name',
          label: this.$t('setting.list.userSetting.grupKendaraan'),
        },
      ]
    },

    query() {
      return {
        get: async (filter) => {
          return this.getVgroup(filter)
        },
        delete: async (id) => {
          return this.deleteVgroup(id)
        },
      }
    },
    vgroupQuery() {
      return {
        get: async (opts) => {
          const filter = {
            pagination: {
              page: opts.page,
              show: opts.limit,
            },
            search: opts.search,
          }

          const res = await this.$apollo.query({
            query: GET_VGROUPS_PAGINATED,
            fetchPolicy: 'no-cache',
            variables: {
              filter: {
                ...filter,
                excludeVgroupId: this.excludeVgroupId,
              },
            },
          })

          const data = {
            metadata: {
              total_count: res.data.vgroupsPaginated.vgroups.pagination.total,
              page: res.data.vgroupsPaginated.vgroups.pagination.page,
            },
            data: {
              paginated_result: res.data.vgroupsPaginated.vgroups.data,
            },
          }

          return data
        },
      }
    },
  },

  mounted() {
    setTimeout(() => {
      this.$apollo.queries.ngroup2Sources.refetch()
    }, 1000)
  },
  methods: {
    async getVgroup(filters) {
      if (this.isAdding) return
      const res = await this.$apollo.query({
        query: GET_NGROUP_2_SOURCES,
        fetchPolicy: 'no-cache',
        variables: {
          filter: {
            ...filters,
            ngroupId: Number(this.ngroupId),
          },
        },
      })

      if (res.data.ngroup2Sources.ngroup2Sources.data.length > 0) this.hasData = true
      else this.hasData = false
      this.loading = false
      this.$apollo.queries.ngroup2Sources.refetch()
      return res.data.ngroup2Sources.ngroup2Sources
    },
    async addVgroup(value) {
      this.loading = true
      const selectedIds = value
      const vgroup = this.vgroups.map((item) => item.vgroupId)

      const input = {
        ngroupId: Number(this.ngroupId),
        vgroupId: vgroup.length > 0 ? [...vgroup, ...selectedIds] : selectedIds,
      }
      const res = await this.$apollo.mutate({
        mutation: UPDATE_NOTIFICATION_GROUP,
        variables: {
          input: input,
        },
      })
      if (res.data.updateNgroup.isSuccessful) {
        this.$mcToast.success(this.$t('global.alert.text.added'))
        this.hasData = true
      } else {
        this.$mcToast.error(res.data.updateNgroup.message)
      }
      this.loading = false
    },
    async deleteVgroup(id) {
      this.loading = true
      const filteredData = this.vgroups.filter((item) => !id.includes(item.vgroupId.toString()))
      const ids = filteredData.map((item) => item.vgroupId)
      const input = {
        ngroupId: Number(this.ngroupId),
        vgroupId: [...new Set(ids)],
      }
      const res = await this.$apollo.mutate({
        mutation: UPDATE_NOTIFICATION_GROUP,
        variables: {
          input: input,
        },
      })
      this.loading = false
      return res.data.updateNgroup.isSuccessful
    },
  },
}
</script>
